import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import "../../../Components/Notes/notes.css";
import { useDispatch, useSelector } from "react-redux";
import { getNoteNumber, setNoteNumber } from "../../../helper/calculation";
import Note4 from "../../../Components/Notes/Note4";
// import Note4B from './Note4B'
// import Note3 from './Note3'
import Notetype3 from "../../../Components/Notes/Notetype3";
import Note5 from "../../../Components/Notes/Note5";
import Note8 from "../../../Components/Notes/Note8";
// import NotePayble from './Notepayble'
import Pattern6 from "../../../Components/Notes/Pattern6";
import Pattern3 from "../../../Components/Notes/Pattern3";
import Pattern5 from "../../../Components/Notes/Pattern5";
import Pattern5b from "../../../Components/Notes/Pattern5b";
import Pattern7 from "../../../Components/Notes/Pattern7";
import NoteLeases from "../../../Components/Notes/NoteLeases";
import NoteEquiteShareCaptial from "../../../Components/Notes/NoteEquiteShareCaptial";
import ConsolePattern1 from "../consoleTabs/ConsolePattern1";
import PopulateFsPatter1 from "./populateFSPattern1";
import PopulateFsPattern2 from "./populateFsPattern2";
import PopulateFsPattern3 from "./populateFsPattern3";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    minHeight: "50vh",
  },
  tabs: {
    maxHeight: "100vh",
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingTop: "3rem",
    paddingBottom: "3rem",
    background: "linear-gradient(45deg, transparent, #E5EEEE)",
    color: "Black",
    fontSize: "1rem",
    width: "260px",
  },
  tab: {
    padding: "12px 12px",
    overflow: "hidden",
    position: "relative",
    fontSize: "5px",
    boxSizing: "border-box",
    minHeight: "55px",
    textAlign: "center",
    flexShrink: 0,
    fontWeight: "500",
    letterSpacing: "0.02857em",
    textTransform: "none",
  },
  TabPanel: {
    width: "100%",
  },
}));

const heading = {
  width: "100%",
  height: "50px",
  backgroundColor: "#E5EEEE",
  position: "sticky",
  top: "80px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // border:'1px solid teal'
};

const headingText = {
  fontSize: "1.2 rem",
  fontWeight: "700",
};

export default function PopulateFsBalanceNote(props) {
  const {
    consoleNotes,
    balanceSheetData,
    groupingData,
    consoleData,
    allcheckdata,
    tab,
    pnlStatementData,
    currentCompProjectId,
    checkKey,
    subsiaryData
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [no, setNo] = useState([]);
  const [value, setValue] = useState("");
  const [math, setMath] = useState("");
  const NoteNo = useSelector((initialState) => initialState.reducer.blNoteNo);

  const handleChange = (event, newValue) => {
    console.log(newValue, "tab index", event);
    setValue(newValue);
  };

  const { loading, isSuccess, response, error_message } = balanceSheetData;
  const currentProjectBs = response?.data?.balance_sheet?.balance_sheet ?? [];
  const fsRows = Object.keys(currentProjectBs);

  useEffect(() => {
    setValue(checkKey);
    setNo(setNoteNumber(fsRows, currentProjectBs));
  }, [checkKey]);

  const getIndexNumber = (line) => {
    try {
      let index = no.findIndex(
        (note) =>
          note?.notes_grp.toLowerCase() === line?.notes_grp.toLowerCase()
      );
      return (index += 2);
    } catch (err) {
      console.log("error", err.message);
      return "00";
    }
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        {fsRows.map((group, groupIndex) => {
          return currentProjectBs[group].map((noteGroup, noteGroupIndex) => (
            <Tab
              className={classes.tab}
              label={
                "Note - " +
                noteGroup.notes_grp
              }
              value={Number(getIndexNumber(noteGroup))}
              {...a11yProps(noteGroupIndex)}
            />
          ));
        })}
      </Tabs>

      {Object.keys(consoleNotes).map((data, key) => (
        <div key={key}>
          {data === "pattern_1" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <TabPanel
                  key={key}
                  className={classes.tab}
                  value={value}
                  index={data.index}
                >
                  <PopulateFsPatter1
                    note_no={data.note_number}
                    groupingData={groupingData}
                    rows={balanceSheetData?.balance_sheet?.balance_sheet}
                    currentCompany={consoleData}
                    // headingData={allcheckdata.map(
                    //   (data) => data.all_data.company
                    // )}
                    subsiary={balanceSheetData?.balance_sheet?.balance_sheet}
                    sybsidiary={[
                      balanceSheetData?.balance_sheet?.balance_sheet,
                    ]}
                    finalSubsidiaryData={balanceSheetData?.project_ids_bs?.map(
                      (data) => data.balance_sheet
                    )}
                    subsiaryData={subsiaryData}
                    browsFs={[]}
                    current_tab={tab}
                    tabData={"bs"}
                    pnlStatementData={pnlStatementData}
                    currentCompProjectId={currentCompProjectId}
                  />
                </TabPanel>
              ))}
            </>
          ) : data === "pattern_2" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <>
                  <TabPanel key={key} value={value} index={data.index}>
                    <PopulateFsPattern2
                      note_no={data.note_number}
                      group={0}
                      groupingData={groupingData}
                      currentCompany={consoleData}
                      subsiaryData={allcheckdata}
                      // headingData={allcheckdata.map(
                      //   (data) => data.all_data.company
                      // )}
                      currentCompProjectId={currentCompProjectId}
                      current_tab={tab}
                      tabData={"bs"}
                    />
                  </TabPanel>
                </>
              ))}
            </>
          ) : data === "pattern_3" ? (
            <>
              {consoleNotes[data].map((data, key) => (
                <TabPanel key={key} value={value} index={data.index}>
                  <PopulateFsPattern3
                    note_no={data.note_number}
                    groupingData={groupingData}
                    currentCompProjectId={currentCompProjectId}
                    currentCompany={consoleData}
                    subsiaryData={allcheckdata}
                    // headingData={allcheckdata.map(
                    //   (data) => data.all_data.company
                    // )}
                    subsidiaryGrouping={
                      groupingData?.response?.data?.browse_fs_grouping ?? []
                    }
                    browsFsGrouping={
                      groupingData?.response?.data?.browse_fs_grouping ?? []
                    }
                    finalSubsidiaryData={
                      groupingData?.response?.data?.project_ids_grouping ?? []
                    }
                    pnlStatementData={pnlStatementData}
                    current_tab={tab}
                    tabData={"bs"}
                  />
                </TabPanel>
              ))}
            </>
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
}
